export const evaluate = (text) => {
    const module = {}; // Create a local module object
    return eval(text); // Execute the text
}